<div class="main-tabs">
  <div class="tabs-content">
    <pa-main-tab-button type="plan" [active]="activeTab === 'plan'" (click)="onSelectTab('plan')" />
    <pa-main-tab-button type="catalog" [active]="activeTab === 'catalog'" (click)="onSelectTab('catalog')" />
    <pa-main-tab-button type="curriculum" [active]="activeTab === 'curriculum'" (click)="onSelectTab('curriculum')" />
  </div>
</div>
